import React, { useEffect, useRef, useState } from "react";
import {
  FaArrowLeft,
  FaCheck,
  FaCheckCircle,
  FaSearch,
  FaTrash,
  FaUpload,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import buildLink from "../../../../../urls";
import axios from "axios";
import MessageAlert from "../../../../../components/messageAlert";
import Loader from "../../../../../components/loader";
import hocStarredPage from "../../../../../components/hocStarredPage";
import { getDetectedOrderType } from "../../../../../functions/getDetectedOrderType";
import { axiosServer } from "../../../../../axiosServer";

const RecivedFromSellerPart1v2 = () => {
  const orderId = useRef(null);
  const upcRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useState("normal");
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  var host = window.location.host;
  const history = useNavigate();
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];

  const handleTrashClick = () => {
    orderId.current.value = "";
    orderId.current.focus();
  };
  const checkOrder = async (e) => {
    e.preventDefault();

    let detectedOrderType = orderStatus;

    if (host == "pda.ishtari.com" || host.startsWith("localhost") || host == "pda.ishtari.com.gh") {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(orderId.current.value);

      if (!success) {
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setOrderStatus(type);
    }

    setLoading(true);

    var url = "";

    let order_type;

    if (host == "pda.ishtari.com" || host.startsWith("localhost") || host == "pda.ishtari.com.gh") {
      order_type = detectedOrderType;
    } else {
      order_type = orderStatus;
    }

    if (order_type == "normal") {
      url =
        buildLink("checkProductDelay") + `&order_id=${orderId.current.value}`;
    } else if (order_type == "return") {
      url =
        buildLink("checkReturnProductDelay") +
        `&order_id=${orderId.current.value}`;
    }
    try {
      await axiosServer.get(url).then((response) => {
        if (response.data.success) {
          history(
            "receivedfromseller2?orderId=" +
              orderId.current.value +
              "&order_status=" +
              order_type,
          );
        } else {
          setMessage(response.data.message);
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }
      });
    } catch (e) {
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
    setLoading(false);
  };

  useEffect(() => {
    orderId.current.focus();
  }, []);

  return (
    <>
      <div className="h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl my-auto">Order Check</h2>
            </div>
          </div>
        </div>
        <div className=" container">
          <form
            onSubmit={(e) => checkOrder(e)}
            className=" flex flex-col gap-5 justify-center"
          >
            {host !== "pda.ishtari.com" && !host.startsWith("localhost") && host !== "pda.ishtari.com.gh" && (
              <div className=" py-1">
                <div className="mb-1">Order Type</div>
                <Select
                  placeholder="Order Type"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "7px",
                      borderColor: state.isFocused ? "grey" : "grey",
                      outline: "red",
                      padding: "8px 5px",
                    }),
                  }}
                  onChange={(e) => setOrderStatus(e.value)}
                  options={options}
                />
              </div>
            )}
            <div className="  flex  justify-center gap-3 items-end">
              <div className=" my-auto relative flex-1 ">
                <div className="mb-1">Order ID</div>
                <input
                  ref={orderId}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Order Id"
                />
                <FaTrash
                  className="absolute top-[55px] transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                  onClick={handleTrashClick}
                />
              </div>
              <button
                type="submit"
                className=" bg-dbase rounded-md text-white px-5 h-12 "
              >
                {" "}
                {loading ? <Loader /> : <FaSearch />}
              </button>
            </div>
          </form>
        </div>
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};
export default hocStarredPage(RecivedFromSellerPart1v2);
